export default "__VITE_ASSET__CAlOBvF7__"